import React from "react";
import { StoryNode } from "../../StoryBook/StoryData";
import { PropertyEditorTypeSelection, PropertyEditorTypeSelectionInterface } from "../PropertyEditorTypeSelection";
import { StringDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/StringDataDefinition";
import { IDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/IDataDefinition";
import { IDesignValidationProvider, ValidationIssue } from "../../../rule-engine-core/Common/IDesignValidationProvider";

class SectionData implements PropertyEditorTypeSelectionInterface {
    editObject: { type: IDataDefinition } = {
        type: new StringDataDefinition(),
    };
    propertyName: string = "type";
    label = "pick type";
    hint = "hint";

    updateCallback: () => void = () => {};
}

class SectionData2 implements PropertyEditorTypeSelectionInterface {
    editObject: { type: IDataDefinition } & IDesignValidationProvider = {
        type: new StringDataDefinition(),
        getDesignValidationIssues(): ValidationIssue[] {
            return [new ValidationIssue("issue", "type"), new ValidationIssue("issue2", "type")];
        },
    };
    propertyName: string = "type";
    label = "pick type";
    hint = "hint";

    updateCallback: () => void = () => {};
}

export const PropertyEditorTypeSelectionStories = [
    new StoryNode(
        (logCallback) => {
            const params = new SectionData();
            return (
                <PropertyEditorTypeSelection
                    sx={{ width: "200px" }}
                    {...params}
                    onChange={() => logCallback(params.editObject.type.type)}
                />
            );
        },
        "Shared",
        "Property Editors",
        "TypeSelection",
        "Default",
    ),
    new StoryNode(
        (logCallback) => {
            const params = new SectionData();
            return (
                <PropertyEditorTypeSelection
                    sx={{ width: "200px" }}
                    error={"Error Text"}
                    {...params}
                    onChange={() => logCallback(params.editObject.type.type)}
                />
            );
        },
        "Shared",
        "Property Editors",
        "TypeSelection",
        "Error",
    ),
    new StoryNode(
        (logCallback) => {
            const params = new SectionData2();
            return (
                <PropertyEditorTypeSelection
                    sx={{ width: "200px" }}
                    {...params}
                    onChange={() => logCallback(params.editObject.type.type)}
                />
            );
        },
        "Shared",
        "Property Editors",
        "TypeSelection",
        "Validation Provider",
    ),
];
